import { PencilIcon, TrashIcon } from '@heroicons/react/24/outline';
import { Form, Link } from '@remix-run/react';
import { GQLAddressFragment } from '@theprintbar/graphql';
import { cn, formConfirm, getFullName } from '@theprintbar/shared';
import { TransparentButton } from '../Button';

interface AddressProps {
	editLink?: string;
	showDelete?: boolean;
	address?: GQLAddressFragment | null;
	title?: string;
	showNameInTitle?: boolean;
	className?: string;
}

export function AddressDetails({ address, showDelete, showNameInTitle, title, className, editLink }: AddressProps) {
	const { id, firstName, company, lastName, city, country, postCode, streetAddress, state, streetAddress2 } = address || {};
	return !!address ? (
		<div className={cn('text-xs lg:text-sm', className)}>
			<h5 className="uppercase mb-2 flex items-center gap-2">
				{showNameInTitle ? getFullName(address) : title || 'Address'}
				{editLink && (
					<Link to={editLink} className="flex items-center gap-1 p-1">
						<PencilIcon className="w-3 h-3" />
						<span className="normal-case text-xs font-thin underline">Edit</span>
					</Link>
				)}
				{showDelete && (
					<Form method="DELETE" onSubmit={formConfirm('Are you sure you want to delete this address?')} className="ml-auto">
						<TransparentButton
							icon={TrashIcon}
							circle
							type="submit"
							name="address"
							iconClass="transition-all group-hover:text-red"
							value={id}
						/>
					</Form>
				)}
			</h5>
			{!address ? (
				<p>Not available</p>
			) : (
				<>
					{company && <p>{company}</p>}
					{!showNameInTitle && (
						<p>
							{firstName} {lastName}
						</p>
					)}
					<p>
						{streetAddress2 ? `${streetAddress2} ` : ''}
						{streetAddress}
					</p>
					<p>
						{city}, {state} {postCode}, {country}
					</p>
				</>
			)}
		</div>
	) : null;
}
